"use client";

import React from "react";
import AuthButton from "../ui/AuthButton";
import { Logo } from "./Logo";
import { UserAvatar } from "./UserAvatar";
import { HeaderMobileMenu } from "./HeaderMobileMenu";
import { MenuButton } from "../ui/MenuButton";
import { useAuth } from "@/hooks/useAuth";
import { useAppStore } from "@/store/useAppStore";
import { Navigation } from "./Navigation";
import { ScoreCard } from "./ScoreCard";

export const Header = () => {
  const { user } = useAuth();
  return (
    <>
      <header className="h-16 bg-black border-b border-[#2A2A2A] sticky top-0 z-40">
        <div className="h-full max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Logo />
            <div className="hidden xl:flex">
              <Navigation />
            </div>
          </div>

          <div className="hidden sm:flex items-center gap-3">
            <ScoreCard />
            <UserAvatar />
            {!user && <AuthButton />}
          </div>

          <MenuButton />
        </div>
      </header>
      <HeaderMobileMenu />
    </>
  );
};
